'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initLazyBackground = exports.initLazyLoad = undefined;

var _vanillaLazyload = require('vanilla-lazyload');

var _vanillaLazyload2 = _interopRequireDefault(_vanillaLazyload);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initLazyLoad = exports.initLazyLoad = function initLazyLoad() {
    return new _vanillaLazyload2.default();
};

var initLazyBackground = exports.initLazyBackground = function initLazyBackground() {
    return new _vanillaLazyload2.default({
        elements_selector: "[data-lazy-background]"
    });
};